var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.61804L10.5451 6.37336L10.6574 6.71885H11.0206H16.0207L11.9755 9.6578L11.6817 9.87132L11.7939 10.2168L13.339 14.9721L9.29389 12.0332L9 11.8197L8.70611 12.0332L4.66099 14.9721L6.20609 10.2168L6.31834 9.87132L6.02445 9.6578L1.97933 6.71885H6.97937H7.34265L7.4549 6.37336L9 1.61804Z",
    stroke: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSmall);
export default __webpack_public_path__ + "static/media/star-small.bcb18ec336fe1afd52a438b09e5445bf.svg";
export { ForwardRef as ReactComponent };